import get from "lodash/get";
import {
    putInvoiceClientLoading,
    putInvoiceClientReject,
    putInvoiceClientRequest,
    putInvoiceClientSuccess,
    putInvoiceClientReset,
} from "../../actions/invoiceClient/put";

export const putInvoiceClient = (body) => async (dispatch, getState) => {
    dispatch(putInvoiceClientLoading());
    try {
        const { data } = await putInvoiceClientRequest(body, getState);
        dispatch(putInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(putInvoiceClientReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(putInvoiceClientReset()); }, 3000);
    }
    return Promise.resolve();
};
